import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'arrayLimitTo', standalone: true, pure: false })
@Injectable({providedIn: 'root'})
export class ArrayLimitToPipe implements PipeTransform {
	
	transform(value, limit) {
		if (!value || !Array.isArray(value) || !limit) {
			return value;
		}
		return value.slice(0, limit);
	}
	
}